export default __webpack_public_path__ + "c6a5cc0d0d4155f3da759096daf74991.svg";